import { create } from 'zustand';

interface DropDownOpenStore {
    orderRowsOpen: { [key: string]: boolean }; // Keys are combinations of accountId and orderId
    setOrderRowOpen: (accountId: number, orderId: number, open: boolean) => void; // Function to toggle row open/close
    clearRows: () => void;
}

// Create the Zustand store
const dropDownStoreOrder = create<DropDownOpenStore>((set) => ({
    orderRowsOpen: {}, // Initialize with an empty object
    setOrderRowOpen: (accountId: number, orderId: number, open: boolean) =>
        set((state) => {
            // Generate a unique key combining accountId and orderId
            const key = `${accountId}-${orderId}`;
            return {
                orderRowsOpen: { ...state.orderRowsOpen, [key]: open }, // Update the specific accountId-orderId pair
            };
        }),
    clearRows: () => set({ orderRowsOpen: {} }),
}));

export default dropDownStoreOrder;
